import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import DataGrid from "components/data-grid";
import ValidatedForm from "components/form";
import { validationSchema, defaultValues } from ".";
import NewAssetForm from "./form";
import { withRouter } from "react-router-dom";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { useAssetFormTypeContext } from "../form-provider";
import { useLoadingContext } from "components/loading-spinner-overlay";
import {updateNewShieldEventFile} from "../../../../services/commonService";
import DataGridItem from "../../../../components/data-grid/data-grid-item";
import Typography from "@material-ui/core/Typography";

const AssetNewPageForm = ({ intl, history, isCommonAsset, defaultCategories }) => {
  const { currentCustomerId } = useCurrentCustomerContext();
  const { type } = useAssetFormTypeContext();
  const { setLoading } = useLoadingContext();

  const genericFileErrorMessage = intl.formatMessage({ id: "fileupload.error.generic.message" });

  const [errorMessage, setErrorMessage] = React.useState(null);

  const handleUpdateNewShield = (asset) => {
        setLoading(false);
        if (!!asset?._id) {
            history.replace(`/asset/details/${asset._id}${isCommonAsset ? "" : `/customer/${currentCustomerId}`}`);
        }
  }

  const handleUpdateNewShieldError = () => {
        setLoading(false);
        setErrorMessage(genericFileErrorMessage)
  }

  const handleSubmitApi = (values) => {
      if (errorMessage) {
         setErrorMessage(null);
      }

      setLoading(true);

      const payload = {
          body: { file: values },
          customerId: currentCustomerId
      }

      updateNewShieldEventFile(payload, handleUpdateNewShield, handleUpdateNewShieldError, isCommonAsset, type);
  }

  return (
    <ValidatedForm initialValues={defaultValues} validationSchema={validationSchema(intl)} onSubmit={handleSubmitApi} loadingControl={false}>
      {({ handleChange, ...props }) => {
        const handleAssetChange = name => ({ base64 }) => handleChange(name)(base64);
        return (
          <DataGrid>
            {errorMessage && <DataGridItem big>
                <Typography variant="body2" color="error">
                    {errorMessage}
                </Typography>
            </DataGridItem>}
            <NewAssetForm
              defaultCategories={defaultCategories}
              onImageChange={handleAssetChange}
              onChange={handleChange}
              {...props}
            />
          </DataGrid>
        );
      }}
    </ValidatedForm>
  );
};

AssetNewPageForm.propTypes = {
  /**
   * Indica si estamos subiendo un asset común
   */
  isCommonAsset: PropTypes.bool,
  /**
   * Categorías por defecto para la creación del asset
   */
  defaultCategories: PropTypes.arrayOf(PropTypes.string),
};

export default injectIntl(withRouter(AssetNewPageForm));
